/* eslint-disable react/no-array-index-key */
import EaBrochures from '@propertypal/shared/src/resources/icons/products/ea-brochures-icon.svg';
import RentalListsMockup from '@propertypal/shared/src/resources/images/rental-lists/ea-brochure-mockup.png';
import ProductsPageHeader from '@propertypal/web-ui/src/headers/products/ProductsPageHeader';
import { Box } from '@propertypal/web-ui/src/layout';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import ProductScreenTabs from '@propertypal/web-ui/src/products/ProductScreenTabs';
import { FeaturesItem, FeaturesList } from '@propertypal/web-ui/src/products/ProductsFeatures.style';
import { Text } from '@propertypal/web-ui/src/typography';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Rental Lists & Brochures - PropertyPal',
  description: 'Print Perfect Brochures. Every Time.',
  url: `/products/estate-agents/paid-social-media-advertising`,
};

const featureItems = [
  `Brochures`,
  `Rentals List`,
  `Sales List`,
  `Window Displays`,
  <span style={{ maxWidth: 270, display: 'block' }}>
    Extra features include map display, extra pages for photos, EPC
  </span>,
  <span style={{ maxWidth: 300, display: 'block' }}>Brochure templates can be accessed via the PropertyPal CMS.</span>,
];

const RentalListsAndBrochures = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsPageHeader
        title="Rental Lists & Brochures"
        text="Print perfect brochures. Every time."
        headingProps={{ mb: 10 }}
        subHeadingProps={{ maxWidth: 370, mb: 0 }}
        icon={<EaBrochures />}
      />
      <ProductScreenTabs
        reverse
        aspectRatio="982/759"
        mockupWidth={550}
        maxW={1080}
        tabsMt={0}
        breakpoint={1080}
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        buttonMt={0}
        mockup={{
          src: RentalListsMockup.src,
          alt: 'Rental Lists & Brochures',
        }}
        content={
          <Box maxWidth={415}>
            <Text mb={20} lineHeight={25} align="left">
              Our brochure product allows you to input information once and effortlessly generate professional brochures
              for your clients.
            </Text>
            <Text mb={20} lineHeight={25} align="left" fontSize={20} fontWeight="800">
              Your colours, your brand
            </Text>
            <Text mb={20} lineHeight={25} align="left">
              Choose from various templates and personalise the design to match your brand seamlessly.
            </Text>
            <FeaturesList>
              {featureItems.map((f, i) => (
                <FeaturesItem key={i}>
                  <Text>{f}</Text>
                </FeaturesItem>
              ))}
            </FeaturesList>
          </Box>
        }
        staticTabs
      />
      <ProductsContact reason="Rental Lists & Brochures" />
    </>
  );
};

export default RentalListsAndBrochures;
